import { CaseData, CaseStatus } from '../../data/types';
import { useAppDispatch } from '../hooks';
import { addExpenseTypeAction, addStatusAction, addTypeAction, deleteExpenseTypeAction, deleteStatusAction, deleteTypeAction, setCaseDataAction, setCaseStatusesAction } from '../reducers/caseDataReducer';

export const useCaseDataActions = () => {

    const dispatch = useAppDispatch();

    const setCaseData = (caseData: CaseData) => {
        dispatch(setCaseDataAction(caseData));
    }
    const setCaseStatuses = (caseStatuses: CaseStatus[]) => {
        dispatch(setCaseStatusesAction(caseStatuses));
    }
    const addType = (typeStr: string) => {
        dispatch(addTypeAction(typeStr));
    }
    const addStatus = (status: CaseStatus) => {
        dispatch(addStatusAction(status));
    }
    const addExpenseType = (typeStr: string) => {
        dispatch(addExpenseTypeAction(typeStr));
    }
    const deleteType = (typeStr: string) => {
        dispatch(deleteTypeAction(typeStr));
    }
    const deleteStatus = (status: CaseStatus) => {
        dispatch(deleteStatusAction(status));
    }
    const deleteExpenseType = (typeStr: string) => {
        dispatch(deleteExpenseTypeAction(typeStr));
    }

    return {
        setCaseData,
        setCaseStatuses,
        addType,
        addStatus,
        addExpenseType,
        deleteType,
        deleteStatus,
        deleteExpenseType
    };
}